"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importDefault(require("react"));
function Channels(_a) {
    var user = _a.user;
    var _b = ra_fetch_1.useApi('backend').index('users.channels', { id: user.id }), channels = _b[0], setChannels = _b[1];
    var _c = ra_fetch_1.useApi('auth').delete('users.channels', { id: user.id }), deleteChannel = _c[0], submitDelete = _c[1];
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Title, null, "Huidige kanalen"),
        react_1.default.createElement(storybook_1.Lists.List, { type: 'grid', className: 'max-h-56 overflow-y-scroll' }, channels.data.sortBy('label').map(function (channel, index) { return react_1.default.createElement(storybook_1.Lists.Item, { key: index },
            react_1.default.createElement(storybook_1.Lists.Content, null,
                react_1.default.createElement(storybook_1.Texts.Primary, { className: 'w-2/3' }, channel.label),
                react_1.default.createElement(storybook_1.Texts.Primary, { className: 'w-§/3' }, channel.role.label)),
            react_1.default.createElement(storybook_1.Lists.Buttons, null,
                react_1.default.createElement(storybook_1.Buttons.Button, { disabled: deleteChannel.loading, className: 'storybook-hide-sm', onClick: function () { return submitDelete({ channel_id: channel.id, role_id: channel.role.id }).then(function () {
                        setChannels(channels.data.clone().delete(channel.id, 'id'));
                    }); } },
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'trash', className: 'storybook-icons-icon text-disabled' })))); })));
}
exports.default = Channels;
